import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

export default function HomePage() {
  const { t } = useTranslation();
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return null;
  }

  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow p-8">
        <h1 className="text-3xl font-bold text-slate-900 mb-2">{t('app.title')}</h1>
        <p className="text-slate-600 mb-8">{t('app.tagline')}</p>
        <div className="flex gap-3">
          <Link
            to="/login"
            className="flex-1 text-center bg-slate-900 text-white rounded px-4 py-2 hover:bg-slate-800"
          >
            {t('home.login')}
          </Link>
          <Link
            to="/signup"
            className="flex-1 text-center border border-slate-300 text-slate-900 rounded px-4 py-2 hover:bg-slate-100"
          >
            {t('home.signup')}
          </Link>
        </div>
      </div>
    </div>
  );
}
